function initializeColorSwatches() {
    // Select all elements with the class 'color-swatch-card'
    const swatchContainers = document.querySelectorAll('.color-swatch-card');

    // Loop through each product's swatch container
    swatchContainers.forEach(swatchContainer => {
        // Get the current product color from the parent div's 'current-color' attribute
        const currentColor = swatchContainer.getAttribute('current-color').trim().toLowerCase();



        // Select all color swatch links inside the container
        const swatches = swatchContainer.querySelectorAll('.color-swatch-card-link');

        // Loop through each swatch to find the one that matches the current color
        swatches.forEach(swatch => {
            // Get the 'data-product-color' attribute of the swatch
            const swatchColor = swatch.getAttribute('data-product-color').trim().toLowerCase();



            // Compare the current color with the swatch color
            if (swatchColor === currentColor) {
                // Add the 'active' class to the matching swatch
                swatch.classList.add('active');
            }
        });
    });
}

// Initialize the swatch logic when the DOM content is fully loaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeColorSwatches);
} else {
    initializeColorSwatches();
}
